export default "__VITE_ASSET__RCaTLIWJ__"